import Vue from 'vue';

const state = {
  liked: false,
  disliked: false,
};

const getters = {};

const actions = {
  GET_INTERACTIONS: function ({ commit, rootState }, id) {
    return Vue.prototype.$axios.get('/videos/' + id + '/interactions').then(
      (response) => {
        commit('SET_LIKED', response.data.liked);
        commit('SET_DISLIKED', response.data.disliked);
        return response;
      },
      (err) => {
        throw new Error(err);
      }
    );
  },
  LIKE_VIDEO: function ({ commit, rootState }, id) {
    return Vue.prototype.$axios.post('/videos/' + id + '/likes').then(
      (response) => {
        return response;
      },
      (err) => {
        throw new Error(err);
      }
    );
  },
  DISLIKE_VIDEO: function ({ commit, rootState }, id) {
    return Vue.prototype.$axios.post('/videos/' + id + '/dislikes').then(
      (response) => {
        return response;
      },
      (err) => {
        throw new Error(err);
      }
    );
  },
  SHARE_VIDEO: function ({ commit, rootState }, id) {
    return Vue.prototype.$axios.post('/videos/' + id + '/shares').then(
      (response) => {
        return response;
      },
      (err) => {
        throw new Error(err);
      }
    );
  },
  VIEW_VIDEO: function ({ commit, rootState }, id) {
    return Vue.prototype.$axios.post('/videos/' + id + '/views').then(
      (response) => {
        return response;
      },
      (err) => {
        throw new Error(err);
      }
    );
  },
};

const mutations = {
  SET_LIKED: (state, liked) => {
    state.liked = liked;
  },
  SET_DISLIKED: (state, disliked) => {
    state.disliked = disliked;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
